import { PageHeader } from '@/components/layout/PageHeader';
import { POS_SHORTCUT_HELP } from '@/constants/posShortcuts';

export function PosKeyboardGuidePage() {
  const categories = [...new Set(POS_SHORTCUT_HELP.map((s) => s.category))];

  return (
    <div className="h-full overflow-y-auto bg-white p-8 dark:bg-slate-900">
      <div className="mx-auto max-w-3xl">
        <PageHeader
          title="POS keyboard shortcut guide"
          description="Train cashiers to complete checkout without mouse or touchscreen. All shortcuts work in the browser and Electron desktop app."
          breadcrumbs={[{ label: 'Billing', to: '/pos' }, { label: 'Guide' }]}
        />
        <div className="mt-8 space-y-8">
          {categories.map((cat) => (
            <section key={cat}>
              <h2 className="mb-3 text-lg font-semibold text-primary-700 dark:text-primary-400">
                {cat}
              </h2>
              <table className="w-full text-sm">
                <tbody>
                  {POS_SHORTCUT_HELP.filter((s) => s.category === cat).map((s) => (
                    <tr key={s.key} className="border-b border-slate-100 dark:border-slate-800">
                      <td className="py-2 pr-4">
                        <kbd className="rounded bg-slate-100 px-2 py-1 font-mono text-xs dark:bg-slate-800">
                          {s.key}
                        </kbd>
                      </td>
                      <td className="py-2 text-slate-700 dark:text-slate-300">{s.action}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
